const EPSILON = 0.000001;

export const parseCoordinatePair = (lat, lon) => {
  const latitudeRaw = String(lat ?? '').trim();
  const longitudeRaw = String(lon ?? '').trim();
  const hasLatitude = latitudeRaw !== '' && latitudeRaw.toLowerCase() !== 'null' && latitudeRaw.toLowerCase() !== 'undefined';
  const hasLongitude = longitudeRaw !== '' && longitudeRaw.toLowerCase() !== 'null' && longitudeRaw.toLowerCase() !== 'undefined';

  if (!hasLatitude && !hasLongitude) {
    return {
      latitude: null,
      longitude: null,
      pairProvided: false,
      technicallyValid: false,
      operationallyValid: false,
      reason: 'missing',
    };
  }

  if (!hasLatitude || !hasLongitude) {
    return {
      latitude: hasLatitude ? Number(latitudeRaw) : null,
      longitude: hasLongitude ? Number(longitudeRaw) : null,
      pairProvided: false,
      technicallyValid: false,
      operationallyValid: false,
      reason: 'incomplete_pair',
    };
  }

  const latitude = Number(latitudeRaw);
  const longitude = Number(longitudeRaw);
  const numeric = Number.isFinite(latitude) && Number.isFinite(longitude);
  const inRange = numeric && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180;

  if (!inRange) {
    return {
      latitude,
      longitude,
      pairProvided: true,
      technicallyValid: false,
      operationallyValid: false,
      reason: numeric ? 'out_of_range' : 'non_numeric',
    };
  }

  const isZeroPair = Math.abs(latitude) <= EPSILON && Math.abs(longitude) <= EPSILON;
  if (isZeroPair) {
    return {
      latitude,
      longitude,
      pairProvided: true,
      technicallyValid: true,
      operationallyValid: false,
      reason: 'placeholder_zero',
    };
  }

  return {
    latitude,
    longitude,
    pairProvided: true,
    technicallyValid: true,
    operationallyValid: true,
    reason: 'valid',
  };
};

export const isTechnicallyValidCoordinatePair = (lat, lon) => parseCoordinatePair(lat, lon).technicallyValid;

export const isOperationallyValidCoordinatePair = (lat, lon) => parseCoordinatePair(lat, lon).operationallyValid;

export const getOperationalCoordinateWarning = (lat, lon) => {
  const parsed = parseCoordinatePair(lat, lon);
  if (parsed.reason === 'placeholder_zero') return 'Koordinat 0,0 terdeteksi sebagai placeholder. Sistem akan memakai fallback lokasi.';
  if (parsed.reason === 'incomplete_pair') return 'Latitude dan Longitude harus diisi berpasangan.';
  return '';
};
